import React, {Component} from 'react';
import TranslatedText from '../../../atoms/TranslatedText';

import './MassSlide.css';
import Video from '../../../atoms/Video';

export default class MassSlide extends Component {
    state = {classes: 'MassSlide-label fade-in one'};

    componentDidMount() {
        this.setState({
            classes: 'MassSlide-label fade-in one',
        });
    }

    render() {
        const {data, number} = this.props;

        const styleImg = data.img
            ? {backgroundImage: `url(${data.img})`}
            : {backgroundImage: ''};

        return (
            <article className="MassSlide">
                <div className={`MassSlide-center MassSlide-center--${number}`}>
                    <div className={this.state.classes}>
                        <TranslatedText tag={data.label} />
                    </div>
                </div>
                <div className="MassSlide-media" style={styleImg}>
                    <Video
                        src={data.video}
                        poster="data:image/gif,AAAA"
                        style={{backgroundImage: `url(${data.poster})`}}
                        autoPlay
                        playsInline
                        muted
                    />
                </div>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/highDefinitionOptics/MassTest/MassSlide.js